export const launcher = {
	linux: 'https://politcubes.com/launcher.jar',
	windows: 'https://politcubes.com/launcher.exe'
}

export const pcDevelopers = 'https://vk.me/politcubes'
export const api = process.env.NODE_ENV === 'production' ? 'https://politcubes.com/api' : 'http://test.local.politcubes.com/api'
export const api3d = process.env.NODE_ENV === 'production' ? 'https://politcubes.com/3dapi' : 'http://test.local.politcubes.com/3dapi'
export const ebalas = process.env.NODE_ENV === 'production' ? 'https://politcubes.com/ebalas' : 'http://test.local.politcubes.com/ebalas'

export function getSession(): string {
	const session = window.localStorage.getItem('session')

	return session ? session : ''
}

export function setSession(session: string): void {
	window.localStorage.setItem('session', session)
}

export function removeSession(): void {
	window.localStorage.removeItem('session')
}

type Base64Result = Promise<string>

const base64 = (file: File): Base64Result => new Promise((resolve, reject) => {
	const reader = new FileReader()
	reader.readAsDataURL(file)
	reader.onload = () => resolve(reader.result as unknown as string)
	reader.onerror = error => reject(error)
})

export async function toBase64(file: File): Promise<string> {
	try {
		const result = await base64(file)

		let i = 0
		while (result[i] !== ',' && i < result.length) {
			i++
		}

		i++
		return result.substring(i, result.length)
	} catch {
		return ''
	}
}
